<template>
    <div
        class="site_content weeduc-admin-content main-container weeduc-admin-site-layout"
        :class="{
            'fixed-site-preview': positionFixedSite,
            'weeduc-admin-site-layout--solo-preview':
                isPreviewOnlyLayout && publishedSiteUrl,
            'weeduc-admin-site-layout--solo-editor':
                isEditorOnlyLayout && publishedSiteUrl,
        }"
    >
        <Teleport to="body" :disabled="!layoutFullscreenImmersive">
            <div
                class="weeduc-admin-site-fs-portal"
                :class="{
                    'weeduc-admin-site-fs-portal--open':
                        layoutFullscreenImmersive,
                    'weeduc-admin-site-fs-portal--dashboard-dark': dark,
                }"
            >
        <div
            v-if="layoutFullscreenImmersive"
            class="weeduc-admin-site-fullscreen-backdrop"
            aria-hidden="true"
            @click.self="closeLayoutFullscreen"
        />
        <div
            class="weeduc-admin-site-layout-stack weeduc-admin-site-layout"
            :class="{
                'weeduc-admin-site-layout-stack--modal':
                    layoutFullscreenImmersive,
            }"
            :aria-modal="layoutFullscreenImmersive ? 'true' : undefined"
            :role="layoutFullscreenImmersive ? 'dialog' : undefined"
            :aria-labelledby="
                layoutFullscreenImmersive
                    ? 'weeduc-admin-site-fullscreen-dialog-title'
                    : undefined
            "
        >
        <div
            v-if="layoutFullscreenImmersive"
            class="weeduc-admin-site-fullscreen-topbar"
        >
            <span
                id="weeduc-admin-site-fullscreen-dialog-title"
                class="weeduc-admin-site-fullscreen-topbar__title"
            >
                Layout do site
            </span>
            <button
                type="button"
                class="weeduc-admin-site-fullscreen-topbar__close"
                aria-label="Fechar tela cheia e voltar ao layout normal"
                @click="closeLayoutFullscreen"
            >
                <fa
                    class="weeduc-admin-site-fullscreen-topbar__close-ico"
                    :icon="['fas', 'xmark']"
                />
                Fechar
            </button>
        </div>
        <div
            class="weeduc-admin-site-editor-live-split"
            :class="{
                'weeduc-admin-site-editor-live-split--has-live': !!publishedSiteUrl,
                'weeduc-admin-site-editor-live-split--preview-only':
                    publishedSiteUrl && isPreviewOnlyLayout,
            }"
        >
            <div
                v-if="publishedSiteUrl"
                class="weeduc-admin-site-preview-toolbar weeduc-admin-site-preview-toolbar--icons"
                role="toolbar"
                aria-label="Ferramentas do preview do site"
            >
                <div class="weeduc-admin-site-preview-toolbar__inner">
                    <button
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn"
                        :class="{
                            'weeduc-admin-site-preview-toolbar__btn--active':
                                layoutPanelMode === 'split',
                        }"
                        title="Dividido: editor e preview"
                        aria-label="Dividido: editor e preview"
                        @click="toggleLayoutPanelMode('split')"
                    >
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="['fas', 'columns']"
                        />
                    </button>
                    <button
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn"
                        :class="{
                            'weeduc-admin-site-preview-toolbar__btn--active':
                                layoutPanelMode === 'editor',
                        }"
                        title="Só editor"
                        aria-label="Só editor"
                        @click="toggleLayoutPanelMode('editor')"
                    >
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="['fas', 'pen-to-square']"
                        />
                    </button>
                    <button
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn"
                        :class="{
                            'weeduc-admin-site-preview-toolbar__btn--active':
                                layoutPanelMode === 'preview',
                        }"
                        title="Só preview"
                        aria-label="Só preview"
                        @click="toggleLayoutPanelMode('preview')"
                    >
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="['fas', 'eye']"
                        />
                    </button>
                    <span
                        class="weeduc-admin-site-preview-toolbar__sep"
                        aria-hidden="true"
                    />
                    <button
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn weeduc-admin-site-preview-toolbar__btn--brand-color"
                        title="Cor da marca do site"
                        aria-label="Cor da marca do site"
                        @click="openBrandColorModal"
                    >
                        <span
                            class="weeduc-admin-site-preview-toolbar__color-swatch"
                            :style="{ backgroundColor: resolvedWebsiteColor }"
                            aria-hidden="true"
                        />
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="['fas', 'palette']"
                        />
                    </button>
                    <span
                        v-show="layoutPanelMode !== 'editor'"
                        class="weeduc-admin-site-preview-toolbar__sep"
                        aria-hidden="true"
                    />
                    <button
                        v-for="item in previewToolbarModes"
                        v-show="layoutPanelMode !== 'editor'"
                        :key="item.id"
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn"
                        :class="{
                            'weeduc-admin-site-preview-toolbar__btn--active':
                                previewDeviceMode === item.id,
                        }"
                        :title="item.hint"
                        :aria-label="item.hint"
                        @click="setPreviewDeviceMode(item.id)"
                    >
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="item.icon"
                        />
                    </button>
                    <button
                        v-show="layoutPanelMode !== 'editor'"
                        type="button"
                        class="weeduc-admin-site-preview-toolbar__btn"
                        :class="{
                            'weeduc-admin-site-preview-toolbar__btn--active':
                                layoutFullscreenImmersive,
                        }"
                        title="Tela cheia: mesmo layout ocupando a tela"
                        aria-label="Tela cheia: mesmo layout ocupando a tela"
                        @click="toggleLayoutFullscreen"
                    >
                        <fa
                            class="weeduc-admin-site-preview-toolbar__ico"
                            :icon="['fas', 'maximize']"
                        />
                    </button>
                </div>
            </div>

            <div
                ref="splitMainRef"
                class="weeduc-admin-site-editor-live-split__main"
                :class="{
                    'weeduc-admin-site-editor-live-split__main--split':
                        publishedSiteUrl && layoutPanelMode === 'split',
                    'weeduc-admin-site-editor-live-split__main--solo-preview':
                        publishedSiteUrl && isPreviewOnlyLayout,
                    'is-split-dragging': splitDragging,
                }"
            >
            <div
                v-show="showEditorInLayout"
                class="weeduc-admin-site-editor-live-split__editor"
            >
        <div
            class="container-form site demo weeduc-admin-site-layout-inner"
            :class="{
                'fixed-site-left': positionFixedSite,
                'dark': websites.typeLayout == 0,
                'light': websites.typeLayout == 1,
            }"
        >
            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco1')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco1
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Banner
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco1_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco1">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file weeduc-admin-site-file-drop">
                            <div
                                class="file-wrapper primary weeduc-admin-site-file-drop__inner"
                            >
                                <div
                                    class="weeduc-admin-site-file-drop__thumb-wrap"
                                    :class="{
                                        'weeduc-admin-site-file-drop__thumb-wrap--empty':
                                            !bloco1_bannerPreview,
                                    }"
                                >
                                    <img
                                        v-if="bloco1_bannerPreview"
                                        :src="bloco1_bannerPreview"
                                        alt=""
                                        class="weeduc-admin-site-file-drop__thumb"
                                    />
                                    <span
                                        v-else
                                        class="weeduc-admin-site-file-drop__placeholder-icon"
                                        aria-hidden="true"
                                    >
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div class="weeduc-admin-site-file-drop__meta">
                                    <span class="text weeduc-admin-site-file-drop__hint">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span
                                        class="text weeduc-admin-site-file-drop__size"
                                    >
                                        1920×1080
                                    </span>
                                </div>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathBanner1"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="bloco1_title"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Endereço da URL:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="https://seucurso.com.br"
                                v-model="bloco1_link"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Somos o maior curso de matemática..."
                                v-model="bloco1_description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco2')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco2
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Listagem de Cursos
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco2_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco2">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Veja o que os alunos estão dizendo"
                                v-model="bloco2_title"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco3')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco3
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Conteúdo Institucional
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco3_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco3">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file weeduc-admin-site-file-drop">
                            <div
                                class="file-wrapper primary weeduc-admin-site-file-drop__inner"
                            >
                                <div
                                    class="weeduc-admin-site-file-drop__thumb-wrap"
                                    :class="{
                                        'weeduc-admin-site-file-drop__thumb-wrap--empty':
                                            !bloco3_bannerPreview,
                                    }"
                                >
                                    <img
                                        v-if="bloco3_bannerPreview"
                                        :src="bloco3_bannerPreview"
                                        alt=""
                                        class="weeduc-admin-site-file-drop__thumb"
                                    />
                                    <span
                                        v-else
                                        class="weeduc-admin-site-file-drop__placeholder-icon"
                                        aria-hidden="true"
                                    >
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div class="weeduc-admin-site-file-drop__meta">
                                    <span class="text weeduc-admin-site-file-drop__hint">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span
                                        class="text weeduc-admin-site-file-drop__size"
                                    >
                                        1920×1080
                                    </span>
                                </div>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathBanner3"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="bloco3_title"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Endereço da URL:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="https://seucurso.com.br"
                                v-model="bloco3_link"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            
                            <div class="custom-quill-wrapper">
                                <QuillEditor
                                    v-model:content="bloco3_description"
                                    toolbar="essential"
                                    contentType="html"
                                    class="custom-quill-editor"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco4')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco4
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Depoimentos
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco4_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco4">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="titleDepoimentos"
                            />
                        </div>
                    </div>
                    <div
                        class="weeduc-admin-site-layout-divider"
                        role="separator"
                        aria-hidden="true"
                    />
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file weeduc-admin-site-file-drop">
                            <div
                                class="file-wrapper primary weeduc-admin-site-file-drop__inner"
                            >
                                <div
                                    class="weeduc-admin-site-file-drop__thumb-wrap"
                                    :class="{
                                        'weeduc-admin-site-file-drop__thumb-wrap--empty':
                                            !(
                                                depoimentos[0].preview ||
                                                depoimentos[0].photoFinal
                                            ),
                                    }"
                                >
                                    <img
                                        v-if="
                                            depoimentos[0].preview ||
                                            depoimentos[0].photoFinal
                                        "
                                        :src="
                                            depoimentos[0].preview ||
                                            depoimentos[0].photoFinal
                                        "
                                        alt=""
                                        class="weeduc-admin-site-file-drop__thumb"
                                    />
                                    <span
                                        v-else
                                        class="weeduc-admin-site-file-drop__placeholder-icon"
                                        aria-hidden="true"
                                    >
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div class="weeduc-admin-site-file-drop__meta">
                                    <span class="text weeduc-admin-site-file-drop__hint">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span
                                        class="text weeduc-admin-site-file-drop__size"
                                    >
                                        1920×1080
                                    </span>
                                </div>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathDepoimento1"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Nome</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nome do aluno"
                                v-model="depoimentos[0].name"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Depoimento do aluno..."
                                v-model="depoimentos[0].description"
                            ></textarea>
                        </div>
                    </div>
                    <div
                        class="weeduc-admin-site-layout-divider"
                        role="separator"
                        aria-hidden="true"
                    />
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file weeduc-admin-site-file-drop">
                            <div
                                class="file-wrapper primary weeduc-admin-site-file-drop__inner"
                            >
                                <div
                                    class="weeduc-admin-site-file-drop__thumb-wrap"
                                    :class="{
                                        'weeduc-admin-site-file-drop__thumb-wrap--empty':
                                            !(
                                                depoimentos[1].preview ||
                                                depoimentos[1].photoFinal
                                            ),
                                    }"
                                >
                                    <img
                                        v-if="
                                            depoimentos[1].preview ||
                                            depoimentos[1].photoFinal
                                        "
                                        :src="
                                            depoimentos[1].preview ||
                                            depoimentos[1].photoFinal
                                        "
                                        alt=""
                                        class="weeduc-admin-site-file-drop__thumb"
                                    />
                                    <span
                                        v-else
                                        class="weeduc-admin-site-file-drop__placeholder-icon"
                                        aria-hidden="true"
                                    >
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div class="weeduc-admin-site-file-drop__meta">
                                    <span class="text weeduc-admin-site-file-drop__hint">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span
                                        class="text weeduc-admin-site-file-drop__size"
                                    >
                                        1920×1080
                                    </span>
                                </div>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathDepoimento2"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Nome</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nome do aluno"
                                v-model="depoimentos[1].name"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Depoimento do aluno..."
                                v-model="depoimentos[1].description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco5')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco5
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Redes Sociais
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco5_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco5">
                    <div class="form-group-container">
                        <div
                            class="col-form-inner col-12 col-md-12 col-lg-12 social"
                            v-for="(item, index) in names"
                            :key="index"
                        >
                            <div
                                class="social-form-group-container socialMedia"
                            >
                                <div class="description">
                                    <span>{{ item }}</span>
                                </div>
                                <div
                                    class="form-check form-switch card-option-switch"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        v-model="activeSocial[index]"
                                        :id="'flexSwitchCheck' + index"
                                    />
                                </div>
                            </div>
                            <div class="social-form-group-container full">
                                <div class="form-input">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="www.facebook.com.br"
                                        v-model="linkSocial[index]"
                                        :disabled="!activeSocial[index]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            </div>

            <div
                v-show="publishedSiteUrl && layoutPanelMode === 'split'"
                class="weeduc-admin-site-editor-live-split__splitter-hit"
                role="separator"
                aria-orientation="vertical"
                aria-label="Redimensionar painéis"
                title="Arraste para ajustar editor e preview"
                @pointerdown.prevent="onPreviewSplitPointerDown"
            >
                <span class="weeduc-admin-site-editor-live-split__splitter-grip" />
            </div>

            <aside
                v-if="publishedSiteUrl && showPreviewInLayout"
                class="weeduc-admin-site-published-preview weeduc-admin-site-editor-live-split__live"
                :style="previewAsideStyle"
            >
                <div class="weeduc-admin-site-published-preview__head">
                    <a
                        :href="publishedSiteUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="weeduc-admin-site-published-preview__head-open"
                        title="Abrir site em nova aba"
                        aria-label="Abrir site em nova aba"
                    >
                        <fa
                            class="weeduc-admin-site-published-preview__head-open-icon"
                            :icon="['fas', 'arrow-up-right-from-square']"
                        />
                    </a>
                    <h3 class="weeduc-admin-site-published-preview__title">
                        Site publicado
                    </h3>
                </div>
                <div
                    class="weeduc-admin-site-published-preview__device"
                    :class="[previewDeviceFrameClasses]"
                >
                    <div
                        class="weeduc-admin-site-published-preview__frame-wrap"
                        :class="{
                            'is-preview-loading': previewIframeLoading,
                        }"
                    >
                        <div
                            v-show="previewIframeLoading"
                            class="weeduc-admin-site-published-preview__frame-loading"
                            aria-live="polite"
                            aria-busy="true"
                        >
                            <div
                                class="weeduc-admin-site-published-preview__spinner"
                                aria-hidden="true"
                            />
                            <span
                                class="weeduc-admin-site-published-preview__loading-text"
                            >
                                Carregando o site…
                            </span>
                        </div>
                        <iframe
                            ref="sitePreviewIframeRef"
                            :src="publishedSiteUrl"
                            class="weeduc-admin-site-published-preview__iframe"
                            title="Preview do site publicado"
                            referrerpolicy="no-referrer-when-downgrade"
                            @load="onPreviewIframeLoad"
                            @error="onPreviewIframeError"
                        />
                    </div>
                </div>
            </aside>
            </div>
        </div>
        </div>
            </div>
        </Teleport>

        <div
            v-if="showInlineSitePreview"
            class="row site demo"
            :class="{
                'fixed-site': positionFixedSite,
                'dark': websites.typeLayout == 0,
                'light': websites.typeLayout == 1,
            }"
        >
            <section
                class="config-form primary col-12"
                :class="!bloco1_active ? 'blur' : ''"
            >
                <div class="box_1">
                    <div class="banner">
                        <div class="banner-content">
                            <img
                                src="@/assets/1920x1080.png"
                                alt=""
                                v-show="!bloco1_banner"
                            />
                            <img
                                :src="bloco1_bannerPreview"
                                alt=""
                                v-show="bloco1_banner"
                            />
                            <div class="banner-text">
                                <h2>{{ bloco1_title }}</h2>
                                <p>{{ bloco1_description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                class="course-info config-form primary col-12 itens-courses"
                :class="!bloco2_active ? 'blur' : ''"
            >
                <p style="margin: 0px">{{ bloco2_title }}</p>
                <div class="box_2" v-for="i in 4" :key="i">
                    <div class="cursos">
                        <div class="banner-content cursos">
                            <img
                                :src="
                                    allCollections && allCollections.length > 0
                                        ? allCollections[
                                              (i - 1) % allCollections.length
                                          ].imageFinalPath2
                                        : require('@/assets/190x112.png')
                                "
                                alt="Imagem do curso"
                                style="
                                    width: 190px;
                                    height: 112px;
                                    object-fit: cover;
                                "
                            />
                            <!-- <div class="banner-text">
                <span v-if="allCollections && allCollections.length > 0">
                  {{ allCollections[(i - 1) % allCollections.length].name }}
                </span>
              </div> -->
                        </div>
                    </div>
                </div>
            </section>
            <section
                class="course-info config-form primary col-12 itens-courses"
                :class="!bloco3_active ? 'blur' : ''"
            >
                <div class="box_3">
                    <div class="cursos">
                        <div
                            class="banner-content cursos d-flex align-items-center"
                        >
                            <div class="banner-image" style="flex: 1">
                                <img
                                    src="@/assets/1920x1080.png"
                                    alt=""
                                    v-show="!bloco3_banner"
                                />
                                <img
                                    :src="bloco3_bannerPreview"
                                    alt=""
                                    v-show="bloco3_banner"
                                />
                            </div>
                            <div
                                class="banner-text"
                                style="flex: 1; position: static"
                            >
                                <h2>{{ bloco3_title }}</h2>
                                <p>{{ bloco3_description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- <section class="config-form primary col-12" :class="!bloco4_active?'blur':''">
        <div class="box_4">
          <div class="banner depoimentos">
            <h2 class="section-title">{{titleDepoimentos}}</h2>
            <div class="depoimentos-slider">
                <div v-for="(depoimento, index) in depoimentos" 
                     :key="index"
                     class="depoimento-slide">
                  <div class="depoimento-content">
                    <div class="depoimento-image">
                      <img :src="depoimento.preview ? depoimento.preview : require('@/assets/user.png')" alt="Foto depoimento" />
                    </div>
                    <div class="depoimento-text">
                      <h3 class="depoimento-nome">{{depoimento?.name ? depoimento.name : 'Nome...'}}</h3>
                      <p class="depoimento-descricao">{{depoimento?.description ? depoimento.description : 'Depoimento...'}}</p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </section> -->
            <section
                class="config-form primary col-12"
                :class="!bloco4_active ? 'blur' : ''"
            >
                <div class="box_4">
                    <div class="banner depoimentos">
                        <h2 class="section-title">{{ titleDepoimentos }}</h2>
                        <div class="depoimentos-slider">
                            <button class="nav-button prev" @click="prevSlide">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
                                    />
                                </svg>
                            </button>
                            <div class="depoimento-slide">
                                <div class="depoimento-content">
                                    <div class="depoimento-image">
                                        <img
                                            :src="
                                                depoimentos[currentIndex]
                                                    ?.preview ||
                                                depoimentos[currentIndex]
                                                    ?.photoFinal ||
                                                require('@/assets/user.png')
                                            "
                                            alt="Foto depoimento"
                                        />
                                    </div>
                                    <div class="depoimento-text">
                                        <h3 class="depoimento-nome">
                                            {{
                                                depoimentos[currentIndex]
                                                    ?.name || 'Nome...'
                                            }}
                                        </h3>
                                        <p class="depoimento-descricao">
                                            {{
                                                depoimentos[currentIndex]
                                                    ?.description ||
                                                'Depoimento...'
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button class="nav-button next" @click="nextSlide">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section
                class="config-form primary col-12"
                :class="!bloco5_active ? 'blur' : ''"
            >
                <div class="box_5">
                    <div class="logoPreview">
                        <img :src="websites.logoFinal" alt="" />
                    </div>
                    <div class="redes-sociais">
                        <div
                            class="rede-social"
                            v-for="(item, index) in names"
                            :key="index"
                            v-show="activeSocial[index]"
                        >
                            <a :href="linkSocial[index]" target="_blank">
                                <fa
                                    :icon="['fa-brands', getSocialIcon(item)]"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="buttons-container weeduc-admin-site-form-actions">
            <button
                type="button"
                @click="saveGeral"
                class="btn btn-block btn-content"
            >
                Salvar e Publicar
            </button>
            <button type="button" class="btn btn-block btn-content">
                Voltar
            </button>
            <button
                type="button"
                @click="clearCache()"
                class="btn btn-block btn-content"
            >
                Limpar Cache
            </button>
        </div>

        <Teleport to="body">
            <div
                v-if="showBrandColorModal"
                class="weeduc-admin-brand-color-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="weeduc-brand-color-title"
                @click.self="closeBrandColorModal"
            >
                <div
                    class="weeduc-admin-brand-color-modal__panel"
                    @click.stop
                >
                    <h3
                        id="weeduc-brand-color-title"
                        class="weeduc-admin-brand-color-modal__title"
                    >
                        Cor da marca
                    </h3>
                    <p class="weeduc-admin-brand-color-modal__lead">
                        Cor principal da marca no site. É gravada no campo
                        <code>color</code>
                        do website.
                    </p>
                    <div class="weeduc-admin-brand-color-modal__row">
                        <label class="weeduc-admin-brand-color-modal__label">
                            Pré-visualização
                            <input
                                v-model="brandColorDraft"
                                class="weeduc-admin-brand-color-modal__native"
                                type="color"
                            />
                        </label>
                        <div class="weeduc-admin-brand-color-modal__hex-wrap">
                            <label
                                class="weeduc-admin-brand-color-modal__label"
                                for="weeduc-brand-color-hex"
                            >
                                Hexadecimal
                            </label>
                            <input
                                id="weeduc-brand-color-hex"
                                v-model.trim="brandColorDraft"
                                type="text"
                                class="form-control weeduc-admin-brand-color-modal__hex"
                                placeholder="#250891"
                                maxlength="7"
                                autocomplete="off"
                                spellcheck="false"
                                @blur="brandColorDraft = normalizeHexInput(brandColorDraft)"
                            />
                        </div>
                    </div>
                    <div class="weeduc-admin-brand-color-modal__actions">
                        <button
                            type="button"
                            class="btn btn-light weeduc-admin-brand-color-modal__btn-cancel"
                            :disabled="savingBrandColor"
                            @click="closeBrandColorModal"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            class="btn btn-content weeduc-admin-brand-color-modal__btn-save"
                            :disabled="savingBrandColor"
                            @click="saveWebsiteBrandColor"
                        >
                            {{ savingBrandColor ? 'Salvando…' : 'Salvar' }}
                        </button>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
    import api from '@/utils/site';
    import websiteApi from '@/utils/Weflix/website';
    import apiSiteContent from '@/utils/Site/content';
    import apiSiteSocialMidia from '@/utils/Site/socialMidia';
    import apiTestimony from '@/utils/Site/testimony.js';
    import apiCollections from '@/utils/Weflix/collections';

    import apiAWS from '@/utils/storage/aws';
    import { mapState, mapMutations } from 'vuex';
    import { toast } from 'vue3-toastify';

    export default {
        data() {
            return {
                showBrandColorModal: false,
                brandColorDraft: '#250891',
                savingBrandColor: false,

                sections: {
                    bloco1: true,
                    bloco2: true,
                    bloco3: true,
                    bloco4: true,
                    bloco5: true,
                },
                listContents: [],
                currentSlide: 0,
                slideInterval: null,

                bloco1_active: false,
                bloco2_active: false,
                bloco3_active: false,
                bloco4_active: false,
                bloco5_active: false,

                bloco1_banner: '',
                bloco1_bannerPreview: null,
                bloco1_title: '',
                bloco1_link: '',
                bloco1_description: '',

                bloco2_title: '',

                bloco3_banner: '',
                bloco3_bannerPreview: null,
                bloco3_title: '',
                bloco3_link: '',
                bloco3_description: '',

                bloco4_title: '',

                positionFixedSite: false,
                /** Pré-visualização mock abaixo do editor; o preview real é o iframe ao lado. */
                showInlineSitePreview: false,

                /** mobile | tablet | desktop | null (nenhum preset; largura manual) */
                previewDeviceMode: 'desktop',
                /** Mesmo layout em tela cheia (overlay); o botão «Amplo» virou isto. */
                layoutFullscreenImmersive: false,
                previewToolbarModes: [
                    {
                        id: 'mobile',
                        hint: 'Mobile: painel estreito (~432px)',
                        icon: ['fas', 'mobile-screen-button'],
                    },
                    {
                        id: 'tablet',
                        hint: 'Tablet: painel 720px',
                        icon: ['fas', 'tablet-screen-button'],
                    },
                    {
                        id: 'desktop',
                        hint: 'Desktop: painel 960px',
                        icon: ['fas', 'desktop'],
                    },
                ],
                /** split | editor | preview */
                layoutPanelMode: 'split',
                /** Largura do painel de preview (px), ajustável pelo divisor */
                previewPaneWidthPx: 720,
                /** Largura do painel antes de ir para Mobile (restaurada no Desktop). */
                lastDesktopPreviewWidth: 520,
                splitDragging: false,
                _splitPointerCleanup: null,
                previewIframeLoading: true,
                _previewIframeLoadTimer: null,

                idSite: null,

                activeSocial: Array(6).fill(false),
                linkSocial: Array(6).fill(''),
                names: [
                    'Facebook',
                    'Instagram',
                    'Youtube',
                    'Linkedin',
                    'Whatsapp',
                    'TikTok',
                ],

                titleDepoimentos: '',
                depoimentos: [
                    {
                        id: null,
                        name: '',
                        photo: '',
                        photoFinal: '',
                        description: '',
                    },
                    {
                        id: null,
                        name: '',
                        photo: '',
                        photoFinal: '',
                        description: '',
                    },
                ],
                allCollections: [],
                currentIndex: 0,
            };
        },
        computed: {
            ...mapState(['token', 'websites', 'dark']),
            /**
             * Cor do website: prioriza `websites.color`; se vazio, usa `company.color` só para exibição.
             */
            resolvedWebsiteColor() {
                const w = this.websites;
                if (!w || typeof w !== 'object' || Array.isArray(w)) {
                    return '#250891';
                }
                const direct = w.color;
                if (
                    direct &&
                    typeof direct === 'string' &&
                    direct.trim() !== ''
                ) {
                    return this.normalizeHexInput(direct);
                }
                const fromCompany = w.company && w.company.color;
                if (
                    fromCompany &&
                    typeof fromCompany === 'string' &&
                    fromCompany.trim() !== ''
                ) {
                    return this.normalizeHexInput(fromCompany);
                }
                return '#250891';
            },
            /** URL do site de vendas retornada na API (ex.: listWebsite[0].url no login). */
            publishedSiteUrl() {
                const w = this.websites;
                if (!w || typeof w !== 'object' || Array.isArray(w)) return '';
                const raw = w.url;
                if (!raw || typeof raw !== 'string') return '';
                let u = raw.trim();
                if (!u) return '';
                if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
                return u.replace(/\/$/, '');
            },
            showEditorInLayout() {
                return this.layoutPanelMode !== 'preview';
            },
            showPreviewInLayout() {
                return (
                    !!this.publishedSiteUrl &&
                    this.layoutPanelMode !== 'editor'
                );
            },
            isPreviewOnlyLayout() {
                return this.layoutPanelMode === 'preview';
            },
            isEditorOnlyLayout() {
                return this.layoutPanelMode === 'editor';
            },
            previewAsideStyle() {
                if (!this.publishedSiteUrl) return {};
                if (this.isPreviewOnlyLayout) {
                    const w = this.previewPaneWidthPx;
                    const tr = this.splitDragging
                        ? 'none'
                        : 'max-width 0.22s ease, width 0.22s ease';
                    /* Mesma largura de painel que em «Dividido»; stretch na altura para o iframe 100% */
                    return {
                        flex: '0 1 auto',
                        width: '100%',
                        maxWidth: `min(${w}px, 100%)`,
                        alignSelf: 'stretch',
                        transition: tr,
                    };
                }
                const w = this.previewPaneWidthPx;
                const tr =
                    this.splitDragging
                        ? 'none'
                        : 'width 0.22s ease, flex-basis 0.22s ease, max-width 0.22s ease';
                return {
                    flex: `0 0 ${w}px`,
                    width: `${w}px`,
                    maxWidth: `${w}px`,
                    transition: tr,
                };
            },
            /** Classes do “moldura” ao redor do iframe por modo. */
            previewDeviceFrameClasses() {
                const m = this.previewDeviceMode;
                return {
                    'weeduc-admin-site-published-preview__device--mobile':
                        m === 'mobile',
                    'weeduc-admin-site-published-preview__device--tablet':
                        m === 'tablet',
                    'weeduc-admin-site-published-preview__device--desktop':
                        m === 'desktop',
                };
            },
        },
        methods: {
            ...mapMutations(['SET_WEBSITES']),

            normalizeHexInput(raw) {
                if (raw === null || raw === undefined) return '#250891';
                let t = String(raw).trim();
                if (!t) return '#250891';
                if (!t.startsWith('#')) t = `#${t}`;
                if (!/^#[0-9A-Fa-f]{6}$/.test(t)) {
                    return '#250891';
                }
                return t.toLowerCase();
            },

            openBrandColorModal() {
                this.brandColorDraft = this.resolvedWebsiteColor;
                this.showBrandColorModal = true;
            },

            closeBrandColorModal() {
                if (this.savingBrandColor) return;
                this.showBrandColorModal = false;
            },

            async saveWebsiteBrandColor() {
                const hex = this.normalizeHexInput(this.brandColorDraft);
                const w = this.websites;
                if (!w || typeof w !== 'object' || Array.isArray(w)) {
                    toast.error('Dados do site indisponíveis.');
                    return;
                }
                this.savingBrandColor = true;
                try {
                    const payload = { ...w, color: hex };
                    const updated = await websiteApi.editWebsite(
                        this.token,
                        w.id,
                        payload
                    );
                    this.SET_WEBSITES({
                        ...w,
                        ...(updated && typeof updated === 'object'
                            ? updated
                            : {}),
                        color: hex,
                    });
                    this.brandColorDraft = hex;
                    toast.success('Cor da marca atualizada.');
                    this.showBrandColorModal = false;
                } catch (err) {
                    console.error(err);
                    toast.error('Não foi possível salvar a cor.');
                } finally {
                    this.savingBrandColor = false;
                }
            },

            /** Larguras do painel direito (px): card + iframe. */
            previewModePaneWidths() {
                /* Ordem: mobile < tablet < desktop (largura do painel direito em px) */
                return {
                    mobile: 432,
                    tablet: 720,
                    desktop: 960,
                };
            },

            toggleLayoutPanelMode(mode) {
                if (this.layoutPanelMode === mode) {
                    if (mode === 'editor' || mode === 'preview') {
                        this.layoutPanelMode = 'split';
                    }
                    return;
                }
                this.layoutPanelMode = mode;
            },

            toggleLayoutFullscreen() {
                this.layoutFullscreenImmersive = !this.layoutFullscreenImmersive;
            },

            closeLayoutFullscreen() {
                this.layoutFullscreenImmersive = false;
            },

            setPreviewDeviceMode(mode) {
                const allowed = ['mobile', 'tablet', 'desktop'];
                if (!allowed.includes(mode)) {
                    return;
                }
                if (mode === this.previewDeviceMode) {
                    this.previewDeviceMode = null;
                    return;
                }
                const widths = this.previewModePaneWidths();
                const wasMobile = this.previewDeviceMode === 'mobile';
                const goesMobile = mode === 'mobile';

                if (goesMobile && !wasMobile) {
                    this.lastDesktopPreviewWidth = Math.max(
                        320,
                        this.previewPaneWidthPx
                    );
                }

                this.previewPaneWidthPx = widths[mode];
                this.previewDeviceMode = mode;
                try {
                    localStorage.setItem(
                        'weeduc_site_layout_preview_width',
                        String(this.previewPaneWidthPx)
                    );
                } catch (_) {}
            },

            clearPreviewIframeLoadTimer() {
                if (this._previewIframeLoadTimer) {
                    clearTimeout(this._previewIframeLoadTimer);
                    this._previewIframeLoadTimer = null;
                }
            },

            armPreviewIframeLoading() {
                if (!this.publishedSiteUrl) return;
                this.previewIframeLoading = true;
                this.clearPreviewIframeLoadTimer();
                this._previewIframeLoadTimer = setTimeout(() => {
                    this.previewIframeLoading = false;
                    this._previewIframeLoadTimer = null;
                }, 60000);
            },

            scrollPublishedSitePreviewToTop() {
                const el = this.$refs.sitePreviewIframeRef;
                if (!el || el.tagName !== 'IFRAME') return;
                try {
                    const win = el.contentWindow;
                    if (!win) return;
                    win.scrollTo(0, 0);
                    const doc = win.document;
                    if (doc?.documentElement) {
                        doc.documentElement.scrollTop = 0;
                    }
                    if (doc?.body) {
                        doc.body.scrollTop = 0;
                    }
                } catch (_) {
                    /* Origem cruzada: não é possível aceder ao documento */
                }
            },

            onPreviewIframeLoad() {
                this.clearPreviewIframeLoadTimer();
                this.previewIframeLoading = false;
                this.$nextTick(() => {
                    this.scrollPublishedSitePreviewToTop();
                    requestAnimationFrame(() => {
                        this.scrollPublishedSitePreviewToTop();
                    });
                });
            },

            onPreviewIframeError() {
                this.clearPreviewIframeLoadTimer();
                this.previewIframeLoading = false;
            },

            onPreviewSplitPointerDown(e) {
                if (!this.publishedSiteUrl || this.layoutPanelMode !== 'split') {
                    return;
                }
                if (e.pointerType === 'mouse' && e.button !== 0) return;

                const target = e.currentTarget;
                const el = this.$refs.splitMainRef;
                const startX = e.clientX;
                const startW = this.previewPaneWidthPx;
                const pointerId = e.pointerId;

                try {
                    target.setPointerCapture(pointerId);
                } catch (_) {
                    return;
                }

                this.splitDragging = true;

                let raf = 0;
                const applyWidth = (clientX) => {
                    const rect = el?.getBoundingClientRect?.();
                    const splitterReserve = 24;
                    const minEditor = 260;
                    const minPreview = 280;
                    const maxPreview = rect
                        ? Math.max(
                              minPreview,
                              rect.width - minEditor - splitterReserve
                          )
                        : 1180;
                    /* Preview à direita do divisor: mover o divisor para a direita (clientX maior)
                     * reduz a largura do preview; para a esquerda, aumenta. */
                    let next = startW - (clientX - startX);
                    next = Math.min(maxPreview, Math.max(minPreview, next));
                    this.previewPaneWidthPx = Math.round(next);
                };

                const onMove = (ev) => {
                    if (ev.pointerId !== pointerId) return;
                    ev.preventDefault();
                    if (raf) cancelAnimationFrame(raf);
                    raf = requestAnimationFrame(() => {
                        raf = 0;
                        applyWidth(ev.clientX);
                    });
                };

                const endDrag = () => {
                    if (raf) cancelAnimationFrame(raf);
                    this.splitDragging = false;
                    try {
                        target.releasePointerCapture(pointerId);
                    } catch (_) {}
                    target.removeEventListener('pointermove', onMove);
                    target.removeEventListener('pointerup', endDrag);
                    target.removeEventListener('pointercancel', endDrag);
                    this._splitPointerCleanup = null;
                    if (this.previewDeviceMode !== 'mobile') {
                        this.lastDesktopPreviewWidth = this.previewPaneWidthPx;
                    }
                    try {
                        localStorage.setItem(
                            'weeduc_site_layout_preview_width',
                            String(this.previewPaneWidthPx)
                        );
                    } catch (_) {}
                };

                this._splitPointerCleanup = endDrag;
                target.addEventListener('pointermove', onMove, {
                    passive: false,
                });
                target.addEventListener('pointerup', endDrag);
                target.addEventListener('pointercancel', endDrag);
            },
            async saveGeral() {
                try {
                    await this.save();
                    await this.saveDepoimentos();
                    await this.editSocialMedia();
                    toast.success('Dados atualizados com sucesso!');
                } catch (error) {
                    toast.error('Erro ao atualizar os dados');
                    console.error('Erro ao atualizar os dados:', error);
                }
            },
            toggleSection(section) {
                this.sections[section] = !this.sections[section];
            },
            getSocialIcon(rede) {
                const icons = {
                    Facebook: 'fa-facebook',
                    Instagram: 'fa-instagram',
                    Youtube: 'fa-youtube',
                    Linkedin: 'fa-linkedin',
                    Whatsapp: 'fa-whatsapp',
                    TikTok: 'fa-tiktok',
                };
                return icons[rede];
            },
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async updateFilePathBanner1(event) {
                const file = event.target.files[0];
                this.bloco1_bannerPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.bloco1_banner = response.token;
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathBanner3(event) {
                const file = event.target.files[0];
                this.bloco3_bannerPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.bloco3_banner = response.token;
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathDepoimento1(event) {
                const file = event.target.files[0];
                this.depoimentos[0].preview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.depoimentos[0].photo = response.token;
                    console.log(this.depoimentos[0].photo);
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathDepoimento2(event) {
                const file = event.target.files[0];
                this.depoimentos[1].preview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.depoimentos[1].photo = response.token;
                    console.log(this.depoimentos[1].photo);
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async save() {
                // Definir os blocos com a ordem correta
                const content_1 = {
                    type: 1, // Banner 1
                    title: this.bloco1_title,
                    description: this.bloco1_description,
                    pathImage: this.bloco1_banner,
                    url: this.bloco1_link,
                    order: 1,
                    status: this.bloco1_active == true ? 1 : 0,
                };

                const content_2 = {
                    type: 2, // Cursos
                    title: this.bloco2_title,
                    description: '',
                    pathImage: '',
                    url: '',
                    order: 2,
                    status: this.bloco2_active == true ? 1 : 0,
                };

                const content_3 = {
                    type: 3, // Banner 2 (Conteúdo Institucional)
                    title: this.bloco3_title,
                    description: this.bloco3_description,
                    pathImage: this.bloco3_banner,
                    url: this.bloco3_link,
                    order: 3,
                    status: this.bloco3_active == true ? 1 : 0,
                };

                const content_4 = {
                    type: 4, // Depoimentos
                    title: this.titleDepoimentos,
                    description: '',
                    pathImage: '',
                    url: '',
                    order: 4,
                    status: this.bloco4_active == true ? 1 : 0,
                };

                const putData = [];
                const postData = [];

                // Verifica quais blocos existem e quais precisam ser criados
                // Ordem: 1-Banner, 2-Cursos, 3-Banner2, 4-Depoimentos
                
                console.log('=== VERIFICANDO BLOCOS EXISTENTES ===');
                console.log('Blocos existentes na API:', this.listContents);
                
                // Bloco 1 (Banner) - type: 1, order: 1
                const existingBloco1 = this.listContents?.find(item => item.type === 1);
                if (existingBloco1?.id) {
                    content_1.id = existingBloco1.id;
                    putData.push(content_1);
                    console.log('✅ Bloco 1 (Banner): Atualizando existente');
                } else {
                    postData.push(content_1);
                    console.log('➕ Bloco 1 (Banner): Criando novo');
                }

                // Bloco 2 (Cursos) - type: 2, order: 2
                const existingBloco2 = this.listContents?.find(item => item.type === 2);
                if (existingBloco2?.id) {
                    content_2.id = existingBloco2.id;
                    putData.push(content_2);
                    console.log('✅ Bloco 2 (Cursos): Atualizando existente');
                } else {
                    postData.push(content_2);
                    console.log('➕ Bloco 2 (Cursos): Criando novo');
                }

                // Bloco 3 (Banner 2 - Conteúdo Institucional) - type: 3, order: 3
                const existingBloco3 = this.listContents?.find(item => item.type === 3);
                if (existingBloco3?.id) {
                    content_3.id = existingBloco3.id;
                    putData.push(content_3);
                    console.log('✅ Bloco 3 (Banner 2): Atualizando existente');
                } else {
                    postData.push(content_3);
                    console.log('➕ Bloco 3 (Banner 2): Criando novo');
                }

                // Bloco 4 (Depoimentos) - type: 4, order: 4
                const existingBloco4 = this.listContents?.find(item => item.type === 4);
                if (existingBloco4?.id) {
                    content_4.id = existingBloco4.id;
                    putData.push(content_4);
                    console.log('✅ Bloco 4 (Depoimentos): Atualizando existente');
                } else {
                    postData.push(content_4);
                    console.log('➕ Bloco 4 (Depoimentos): Criando novo');
                }

                // Verificar quantos blocos existem vs quantos precisam ser criados
                const totalItems = putData.length + postData.length;
                const existingCount = this.listContents?.length || 0;
                
                console.log(`=== RESUMO ===`);
                console.log(`Blocos existentes na API: ${existingCount}`);
                console.log(`Blocos para atualizar (PUT): ${putData.length}`);
                console.log(`Blocos para criar (POST): ${postData.length}`);
                console.log(`Total de operações: ${totalItems}`);
                
                // Se não há dados para enviar, algo está errado
                if (totalItems === 0) {
                    console.warn('⚠️ ATENÇÃO: Nenhum bloco para enviar!');
                    toast.warning('Nenhum bloco para enviar');
                    return;
                }

                console.log('Dados existentes (listContents):', this.listContents);
                console.log('Dados para PUT (atualizar):', putData);
                console.log('Dados para POST (criar):', postData);
                
                // Debug: verificar cada bloco individualmente
                console.log('Bloco 1 - Existente:', existingBloco1);
                console.log('Bloco 2 - Existente:', existingBloco2);
                console.log('Bloco 3 - Existente:', existingBloco3);
                console.log('Bloco 4 - Existente:', existingBloco4);

                try {
                    // Atualiza itens existentes
                    if (putData.length > 0) {
                        console.log('Executando PUT para', putData.length, 'itens existentes');
                        const putResponse = await apiSiteContent.putContentData(
                            this.token,
                            putData
                        );
                        console.log('PUT Response:', putResponse);
                    }
                    
                    // Cria novos itens
                    if (postData.length > 0) {
                        console.log('Executando POST para', postData.length, 'novos itens');
                        const postResponse = await apiSiteContent.postContentData(
                            this.token,
                            postData
                        );
                        console.log('POST Response:', postResponse);
                    }
                    
                    // Log de confirmação das operações
                    if (putData.length > 0) {
                        console.log(`✅ ${putData.length} blocos serão atualizados`);
                    }
                    if (postData.length > 0) {
                        console.log(`✅ ${postData.length} blocos serão criados`);
                    }
                    
                    console.log('Limpando cache e recarregando dados...');
                    await this.clearCache();
                    console.log('Cache limpo, aguardando 2 segundos antes de recarregar...');
                    
                    // Aguarda 2 segundos para garantir que o backend processou
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    
                    console.log('Chamando getContetData...');
                    await this.getContetData();
                    console.log('getContetData concluído');
                    
                    // Teste adicional: verificar se os dados foram realmente salvos
                    console.log('=== TESTE ADICIONAL: Verificando dados após 5 segundos ===');
                    setTimeout(async () => {
                        try {
                            const testResponse = await apiSiteContent.getContentData(this.token);
                            console.log('=== DADOS APÓS 5 SEGUNDOS ===');
                            console.log('Quantidade de itens:', testResponse?.length);
                            console.log('Dados completos:', testResponse);
                        } catch (error) {
                            console.error('Erro no teste adicional:', error);
                        }
                    }, 5000);
                    
                } catch (error) {
                    toast.error('Erro ao salvar os dados');
                    console.error('Erro detalhado:', error);
                }
            },
            async clearCache() {
                try {
                    await api.clearCache(this.token);
                    toast.success('Cache limpo com sucesso!');
                } catch (error) {
                    toast.error('Erro ao limpar cache.');
                }
            },
            async saveDepoimentos() {
                const putData = [];
                const postData = [];

                this.depoimentos.forEach((depoimento, index) => {
                    const item = {
                        name: depoimento.name,
                        description: depoimento.description,
                        photo: depoimento.photo,
                    };

                    if (depoimento.id) {
                        item.id = depoimento.id;
                        putData.push(item);
                    } else {
                        postData.push(item);
                    }
                });

                try {
                    if (putData.length > 0) {
                        await apiTestimony.putTestomonytData(
                            this.token,
                            putData
                        );
                    }
                    if (postData.length > 0) {
                        await apiTestimony.postTestomonytData(
                            this.token,
                            postData
                        );
                    }
                    this.getDataTestimony();
                } catch (error) {
                    toast.error('Erro ao salvar depoimentos');
                    console.error('Erro ao salvar depoimentos:', error);
                }
            },
            async getCollections() {
                try {
                    const response = await apiCollections.getCollection(
                        this.token
                    );
                    const sortedCollections = response.sort((a, b) => {
                        const orderA = Number(a.order) || 0;
                        const orderB = Number(b.order) || 0;
                        return orderA - orderB;
                    });
                    this.allCollections = [...sortedCollections];
                    console.log(this.allCollections);
                } catch (error) {
                    toast.error('Erro ao obter dados das coleções');
                    console.error('Erro ao obter dados das coleções:', error);
                }
            },
            async getContetData() {
                try {
                    console.log('=== INICIANDO getContetData ===');
                    const response = await apiSiteContent.getContentData(
                        this.token
                    );
                    this.listContents = response;
                    console.log('=== DADOS RECEBIDOS DA API ===');
                    console.log('Quantidade de itens:', response?.length);
                    console.log('Dados completos:', response);
                    
                    // Log detalhado de cada item
                    if (response && response.length > 0) {
                        response.forEach((item, index) => {
                            console.log(`Item ${index + 1}:`, {
                                id: item.id,
                                type: item.type,
                                title: item.title,
                                status: item.status,
                                order: item.order
                            });
                        });
                    }
                    
                    // Primeiro, desativa todos os blocos
                    this.bloco1_active = false;
                    this.bloco2_active = false;
                    this.bloco3_active = false;
                    this.bloco4_active = false;
                    
                    // Limpa os dados dos blocos
                    this.bloco1_title = '';
                    this.bloco1_description = '';
                    this.bloco1_banner = '';
                    this.bloco1_bannerPreview = null;
                    this.bloco1_link = '';
                    
                    this.bloco2_title = '';
                    
                    this.bloco3_title = '';
                    this.bloco3_description = '';
                    this.bloco3_banner = '';
                    this.bloco3_bannerPreview = null;
                    this.bloco3_link = '';
                    
                    this.bloco4_title = '';
                    
                    console.log('=== ATIVANDO APENAS BLOCOS EXISTENTES ===');
                    
                    if (response.length > 0) {
                        // Processa cada bloco retornado pela API
                        response.forEach((item, index) => {
                            console.log(`Processando item ${index + 1}:`, {
                                type: item.type,
                                title: item.title,
                                status: item.status
                            });
                            
                            switch (item.type) {
                                case 1: // Banner
                                    this.bloco1_active = item.status == 1 ? true : false;
                                    this.bloco1_banner = item.pathImage;
                                    this.bloco1_bannerPreview = item.pathImageFinal;
                                    this.bloco1_title = item.title;
                                    this.bloco1_link = item.url;
                                    this.bloco1_description = item.description;
                                    console.log('✅ Bloco 1 (Banner) ativado:', this.bloco1_active);
                                    break;
                                    
                                case 2: // Cursos
                                    this.bloco2_active = item.status == 1 ? true : false;
                                    this.bloco2_title = item.title;
                                    console.log('✅ Bloco 2 (Cursos) ativado:', this.bloco2_active);
                                    break;
                                    
                                case 3: // Banner 2 (Conteúdo Institucional)
                                    this.bloco3_active = item.status == 1 ? true : false;
                                    this.bloco3_banner = item.pathImage;
                                    this.bloco3_bannerPreview = item.pathImageFinal;
                                    this.bloco3_title = item.title;
                                    this.bloco3_link = item.url;
                                    this.bloco3_description = item.description;
                                    console.log('✅ Bloco 3 (Banner 2) ativado:', this.bloco3_active);
                                    break;
                                    
                                case 4: // Depoimentos
                                    this.bloco4_active = item.status == 1 ? true : false;
                                    this.bloco4_title = item.title;
                                    console.log('✅ Bloco 4 (Depoimentos) ativado:', this.bloco4_active);
                                    break;
                                    
                                default:
                                    console.warn('⚠️ Tipo de bloco desconhecido:', item.type);
                            }
                        });
                        
                        console.log('=== STATUS FINAL DOS BLOCOS ===');
                        console.log('Bloco 1 (Banner):', this.bloco1_active);
                        console.log('Bloco 2 (Cursos):', this.bloco2_active);
                        console.log('Bloco 3 (Banner 2):', this.bloco3_active);
                        console.log('Bloco 4 (Depoimentos):', this.bloco4_active);
                    }
                } catch (error) {
                    toast.error('Erro ao obter dados dos blocos');
                    console.error('Erro ao obter dados dos blocos:', error);
                }
            },
            async editSocialMedia() {
                const socialData = [];
                const newItems = [];

                console.log('=== EDITANDO SOCIAL MEDIA ===');
                console.log('activeSocial:', this.activeSocial);
                console.log('linkSocial:', this.linkSocial);
                console.log('data (itens existentes):', this.data);

                this.linkSocial.forEach((link, index) => {
                    const id = this.data.find(item => item.type === index)?.id;
                    const status = this.activeSocial[index] ? 1 : 0;
                    const url = link ? link : null;
                    const type = index;
                    const name = this.names[index];

                    console.log(`Processando ${name} (index ${index}):`, {
                        link,
                        activeSocial: this.activeSocial[index],
                        status,
                        id,
                        hasExistingItem: !!id
                    });

                    if (id) {
                        // Item existente - sempre envia PUT (mesmo para desativar)
                        socialData.push({ id, name, type, url, status });
                        console.log(`✅ ${name}: Enviando PUT (item existente)`);
                    } else if (this.activeSocial[index] && link !== '') {
                        // Novo item - só cria se estiver ativo e com link
                        newItems.push({ name, type, url, status });
                        console.log(`➕ ${name}: Enviando POST (novo item)`);
                    } else {
                        console.log(`⏭️ ${name}: Ignorando (sem item existente e não ativo)`);
                    }
                });
                try {
                    if (socialData.length > 0) {
                        // Atualiza os itens existentes
                        await apiSiteSocialMidia.putSocialMidiastData(
                            this.token,
                            socialData
                        );
                    }

                    if (newItems.length > 0) {
                        // Cria novos itens
                        await apiSiteSocialMidia.postSocialMidiastData(
                            this.token,
                            newItems
                        );
                    }

                    // Recarrega os dados após a atualização/criação
                    this.getDataSocialMedia();
                } catch (error) {
                    toast.error('Erro ao atualizar as mídias sociais');
                    console.error(error);
                }
            },
            async getDataSocialMedia() {
                try {
                    const response =
                        await apiSiteSocialMidia.getSocialMidiastData(
                            this.token
                        );
                    
                    console.log('=== DADOS RECEBIDOS DA API SOCIAL MEDIA ===');
                    console.log('Response completa:', response);
                    
                    this.data = response;
                    this.bloco5_active = response.length > 0 ? true : false;
                    
                    // Limpa os arrays antes de preencher
                    this.activeSocial = Array(6).fill(false);
                    this.linkSocial = Array(6).fill('');
                    
                    console.log('Arrays limpos:');
                    console.log('activeSocial:', this.activeSocial);
                    console.log('linkSocial:', this.linkSocial);
                    
                    this.data.forEach((item, index) => {
                        console.log(`Processando item ${index}:`, {
                            type: item.type,
                            name: item.name,
                            status: item.status,
                            url: item.url
                        });
                        
                        this.activeSocial[item.type] = item.status === 1;
                        this.linkSocial[item.type] = item.url;
                    });
                    
                    console.log('Arrays após processamento:');
                    console.log('activeSocial:', this.activeSocial);
                    console.log('linkSocial:', this.linkSocial);
                    
                } catch (error) {
                    toast.error('Erro ao obter dados das mídias sociais');
                    console.error(error);
                }
            },
            nextSlide() {
                if (this.depoimentos.length === 0) return;
                this.currentIndex =
                    (this.currentIndex + 1) % this.depoimentos.length;
            },
            prevSlide() {
                if (this.depoimentos.length === 0) return;
                this.currentIndex =
                    (this.currentIndex - 1 + this.depoimentos.length) %
                    this.depoimentos.length;
            },
            async getDataTestimony() {
                try {
                    const response = await apiTestimony.getTestomonytData(
                        this.token
                    );
                    console.debug(response.data);
                    if (response.data.length > 0) {
                        this.depoimentos = response.data;
                        this.currentIndex = 0; // Reinicia o índice ao carregar
                    }
                } catch (error) {
                    toast.error('Erro ao obter dados dos depoimentos');
                    console.error(error);
                }
            },
            // async getDataTestimony(){
            //   try {
            //     const response = await apiTestimony.getTestomonytData(this.token);
            //     console.debug(response.data)
            //     if(response.data.length > 0){
            //       this.depoimentos = response.data;
            //     } else {
            //       // this.depoimentos = [];
            //     }
            //   } catch (error) {
            //     console.error(error);
            //   }
            // }
        },
        watch: {
            publishedSiteUrl(newVal, oldVal) {
                if (!newVal) return;
                if (oldVal !== undefined && newVal !== oldVal) {
                    this.armPreviewIframeLoading();
                }
            },
            showPreviewInLayout(visible) {
                if (visible && this.publishedSiteUrl) {
                    this.armPreviewIframeLoading();
                } else {
                    this.clearPreviewIframeLoadTimer();
                    if (!visible) {
                        this.previewIframeLoading = false;
                    }
                }
            },
            layoutFullscreenImmersive(val) {
                if (typeof document === 'undefined') return;
                document.body.style.overflow = val ? 'hidden' : '';
                if (val) {
                    this._onFullscreenEscape = (e) => {
                        if (e.key === 'Escape') {
                            this.closeLayoutFullscreen();
                        }
                    };
                    window.addEventListener('keydown', this._onFullscreenEscape);
                    this.$nextTick(() => {
                        setTimeout(() => this.scrollPublishedSitePreviewToTop(), 80);
                        setTimeout(() => this.scrollPublishedSitePreviewToTop(), 400);
                    });
                } else if (this._onFullscreenEscape) {
                    window.removeEventListener(
                        'keydown',
                        this._onFullscreenEscape
                    );
                    this._onFullscreenEscape = null;
                }
            },
            previewDeviceMode() {
                if (!this.publishedSiteUrl) return;
                this.$nextTick(() => {
                    setTimeout(() => this.scrollPublishedSitePreviewToTop(), 120);
                });
            },
        },
        components: {},
        created() {
            this.getContetData();
            this.getDataSocialMedia();
            this.getDataTestimony();
            this.getCollections();
        },
        mounted() {
            try {
                const s = localStorage.getItem(
                    'weeduc_site_layout_preview_width'
                );
                if (s) {
                    const n = parseInt(s, 10);
                    if (!Number.isNaN(n) && n >= 260 && n <= 1200) {
                        this.previewPaneWidthPx = n;
                    }
                }
                this.lastDesktopPreviewWidth = this.previewPaneWidthPx;
            } catch (_) {}
        },
        beforeUnmount() {
            if (typeof this._splitPointerCleanup === 'function') {
                this._splitPointerCleanup();
            }
            this.clearPreviewIframeLoadTimer();
            if (typeof document !== 'undefined') {
                document.body.style.overflow = '';
            }
            if (this._onFullscreenEscape) {
                window.removeEventListener(
                    'keydown',
                    this._onFullscreenEscape
                );
                this._onFullscreenEscape = null;
            }
        },
    };
</script>
<style scoped>
    @import '@/css/weeduc/admin/content.css';

    .weeduc-admin-site-editor-live-split {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        width: 100%;
    }

    .weeduc-admin-site-preview-toolbar {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        padding: 0.35rem 0.5rem;
        border-radius: 10px;
        border: 1px solid #e8eaf0;
        background: #f4f5f8;
    }

    .weeduc-admin-site-preview-toolbar--icons .weeduc-admin-site-preview-toolbar__inner {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.3rem;
    }

    .weeduc-admin-site-preview-toolbar__sep {
        width: 1px;
        height: 1.2rem;
        margin: 0 0.15rem;
        flex-shrink: 0;
        background: #cfd4db;
        border-radius: 1px;
    }

    .weeduc-admin-site-layout--solo-editor.weeduc-admin-site-layout
        .weeduc-admin-site-editor-live-split {
        width: 100%;
        max-width: min(1920px, 100%);
        margin-left: auto;
        margin-right: auto;
    }

    .weeduc-admin-site-layout--solo-editor
        .weeduc-admin-site-editor-live-split__main {
        width: 100%;
        max-width: 100%;
    }

    .weeduc-admin-site-layout--solo-editor
        .weeduc-admin-site-editor-live-split__editor {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        margin-left: 0;
        margin-right: 0;
        box-sizing: border-box;
    }

    .weeduc-admin-site-layout--solo-editor
        .weeduc-admin-site-editor-live-split__editor
        .weeduc-admin-site-layout-inner {
        width: 100%;
        max-width: 100%;
    }

    /*
     * Portal no body: o overlay deixava de cobrir a sidebar porque um ancestral
     * do admin cria stacking context (overflow/transform). Teleport + z-index alto.
     */
    .weeduc-admin-site-fs-portal {
        display: contents;
    }

    .weeduc-admin-site-fs-portal--open {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 11000;
        pointer-events: none;
    }

    .weeduc-admin-site-fs-portal--open .weeduc-admin-site-fullscreen-backdrop,
    .weeduc-admin-site-fs-portal--open .weeduc-admin-site-layout-stack--modal {
        pointer-events: auto;
    }

    /* Modal layout: overlay + painel ~95% da viewport */
    .weeduc-admin-site-fullscreen-backdrop {
        position: fixed;
        inset: 0;
        z-index: 0;
        background: rgba(15, 23, 42, 0.52);
        -webkit-backdrop-filter: blur(3px);
        backdrop-filter: blur(3px);
    }

    .weeduc-admin-site-layout-stack {
        width: 100%;
    }

    .weeduc-admin-site-layout-stack--modal {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        width: min(96vw, 1680px);
        height: 95vh;
        max-width: 96vw;
        max-height: 95vh;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: 14px;
        box-shadow:
            0 25px 50px -12px rgba(0, 0, 0, 0.38),
            0 0 0 1px rgba(0, 0, 0, 0.06);
        background: #eef0f4;
    }

    .weeduc-admin-site-fullscreen-topbar {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        padding: 0.5rem 1rem;
        border-bottom: 1px solid #e8eaf0;
        background: #fff;
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-fullscreen-topbar {
        padding: 0.65rem 1.25rem;
        min-height: 3.25rem;
        box-sizing: border-box;
        box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-fullscreen-topbar__title {
        font-size: 1.02rem;
        letter-spacing: -0.02em;
    }

    .weeduc-admin-site-fullscreen-topbar__title {
        font-weight: 600;
        font-size: 0.95rem;
        color: #1f2937;
    }

    .weeduc-admin-site-fullscreen-topbar__close {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0.4rem 0.75rem;
        border-radius: 8px;
        border: 1px solid #d8dce4;
        background: #fff;
        color: #374151;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        font-family: inherit;
        transition:
            border-color 0.15s ease,
            color 0.15s ease,
            background 0.15s ease;
    }

    .weeduc-admin-site-fullscreen-topbar__close:hover {
        border-color: rgba(37, 8, 145, 0.35);
        color: #250891;
    }

    .weeduc-admin-site-fullscreen-topbar__close-ico {
        width: 0.875rem;
        height: 0.875rem;
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-editor-live-split {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-editor-live-split__main {
        min-height: 0;
        flex: 1 1 auto;
    }

    /* Barra de ferramentas do preview: “chip” abaixo do cabeçalho do modal */
    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-preview-toolbar {
        flex-shrink: 0;
        margin: 0.5rem 0.75rem 0.35rem;
        padding: 0.4rem 0.5rem;
        border-radius: 10px;
        border-color: #e2e5eb;
        background: #fff;
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-preview-toolbar--icons
        .weeduc-admin-site-preview-toolbar__inner {
        gap: 0.35rem;
    }

    .weeduc-admin-site-preview-toolbar__btn {
        font-family: inherit;
        font-size: 0;
        font-weight: 500;
        line-height: 1;
        padding: 0;
        width: 2.125rem;
        height: 2.125rem;
        min-width: 2.125rem;
        border-radius: 8px;
        border: 1px solid #d8dce4;
        background: #fff;
        color: #374151;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition:
            background 0.15s ease,
            border-color 0.15s ease,
            color 0.15s ease;
    }

    .weeduc-admin-site-preview-toolbar__ico {
        width: 1rem;
        height: 1rem;
        vertical-align: middle;
    }

    .weeduc-admin-site-preview-toolbar__btn:hover {
        border-color: rgba(37, 8, 145, 0.35);
        color: #250891;
    }

    .weeduc-admin-site-preview-toolbar__btn--active {
        color: #fff;
        background: linear-gradient(135deg, #3d2bb3 0%, #250891 100%);
        border-color: transparent;
    }

    .weeduc-admin-site-preview-toolbar__btn--active .weeduc-admin-site-preview-toolbar__ico {
        color: #fff;
    }

    .weeduc-admin-site-preview-toolbar__btn--brand-color {
        gap: 0.3rem;
        width: auto;
        min-width: 2.5rem;
        padding-left: 0.4rem;
        padding-right: 0.45rem;
    }

    .weeduc-admin-site-preview-toolbar__color-swatch {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        flex-shrink: 0;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
    }

    .weeduc-admin-brand-color-modal {
        position: fixed;
        inset: 0;
        z-index: 10050;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        background: rgba(15, 18, 26, 0.45);
        backdrop-filter: blur(2px);
    }

    .weeduc-admin-brand-color-modal__panel {
        width: 100%;
        max-width: 22rem;
        padding: 1.25rem 1.35rem;
        border-radius: 12px;
        background: #fff;
        border: 1px solid #e8eaf0;
        box-shadow: 0 12px 40px rgba(15, 18, 26, 0.18);
    }

    .weeduc-admin-brand-color-modal__title {
        margin: 0 0 0.35rem;
        font-size: 1.05rem;
        font-weight: 600;
        color: #1a1d24;
    }

    .weeduc-admin-brand-color-modal__lead {
        margin: 0 0 1rem;
        font-size: 13px;
        line-height: 1.45;
        color: #5c6370;
    }

    .weeduc-admin-brand-color-modal__lead code {
        font-size: 0.85em;
        padding: 0.05rem 0.3rem;
        border-radius: 4px;
        background: #f0f2f6;
        color: #374151;
    }

    .weeduc-admin-brand-color-modal__row {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 1rem;
        margin-bottom: 1.15rem;
    }

    .weeduc-admin-brand-color-modal__label {
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        font-size: 12px;
        font-weight: 600;
        color: #4b5563;
    }

    .weeduc-admin-brand-color-modal__native {
        width: 3.25rem;
        height: 2.25rem;
        padding: 0;
        border: 1px solid #d8dce4;
        border-radius: 8px;
        cursor: pointer;
        background: #fff;
    }

    .weeduc-admin-brand-color-modal__hex-wrap {
        flex: 1 1 140px;
        min-width: 0;
    }

    .weeduc-admin-brand-color-modal__hex {
        font-family: ui-monospace, monospace;
        font-size: 14px;
    }

    .weeduc-admin-brand-color-modal__actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        flex-wrap: wrap;
    }

    .weeduc-admin-brand-color-modal__btn-cancel {
        border: 1px solid #d8dce4;
    }

    .weeduc-admin-site-editor-live-split__main {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 0;
        width: 100%;
        min-width: 0;
    }

    /* Dividido: colunas com a mesma altura útil da viewport (iframe 100% + scroll interno) */
    .weeduc-admin-site-editor-live-split__main.weeduc-admin-site-editor-live-split__main--split {
        align-items: stretch;
        min-height: calc(100vh - 9.5rem);
    }

    .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__editor {
        flex: 1 1 auto;
        min-width: 180px;
    }

    /*
     * Modal (Teleport): o split usava min-height: 100vh e o editor não rolava;
     * sem ancestral .weeduc-admin-site-layout os file-drops quebravam — a classe
     * foi reposta no stack. Aqui forçamos altura do split ao painel + scroll na coluna.
     */
    .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-editor-live-split__main.weeduc-admin-site-editor-live-split__main--split {
        min-height: 0;
        flex: 1 1 auto;
        overflow: hidden;
        align-items: stretch;
    }

    .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__editor {
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 0;
        max-height: 100%;
        -webkit-overflow-scrolling: touch;
        padding: 0.35rem 0.5rem 0.65rem 0.65rem;
        box-sizing: border-box;
        background: linear-gradient(180deg, #f7f8fa 0%, #f0f2f5 100%);
        border-radius: 0 0 0 10px;
    }

    .weeduc-admin-site-layout-stack--modal .weeduc-admin-site-layout-inner {
        min-height: 0;
        padding-right: 0.15rem;
        padding-bottom: 1rem;
    }

    .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-layout-inner
        > section.config-form.primary.col-12 {
        margin-bottom: 0.85rem;
    }

    .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-layout-inner
        > section.config-form.primary.col-12:last-child {
        margin-bottom: 0;
    }

    /* Coluna do iframe: contraste suave e separador */
    .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__live.weeduc-admin-site-published-preview {
        border-left: 1px solid #e2e5eb;
        border-radius: 0 0 10px 0;
        background: linear-gradient(180deg, #fafbfc 0%, #f4f5f8 100%);
        box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.7);
    }

    .weeduc-admin-site-editor-live-split__main:not(
            .weeduc-admin-site-editor-live-split__main--split
        )
        .weeduc-admin-site-editor-live-split__editor {
        flex: 1 1 100%;
        width: 100%;
    }

    .weeduc-admin-site-editor-live-split__editor {
        min-width: 0;
    }

    .weeduc-admin-site-editor-live-split__splitter-hit {
        flex: 0 0 20px;
        width: 20px;
        align-self: stretch;
        min-height: 160px;
        margin: 0 -6px;
        padding: 0 6px;
        box-sizing: border-box;
        display: flex;
        align-items: stretch;
        justify-content: center;
        cursor: col-resize;
        touch-action: none;
        z-index: 2;
        user-select: none;
    }

    .weeduc-admin-site-editor-live-split__splitter-grip {
        align-self: stretch;
        width: 5px;
        min-height: 120px;
        margin: 4px 0;
        border-radius: 4px;
        background: #c5cad4;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
        transition: background 0.15s ease, box-shadow 0.15s ease;
    }

    .weeduc-admin-site-editor-live-split__splitter-hit:hover
        .weeduc-admin-site-editor-live-split__splitter-grip,
    .weeduc-admin-site-editor-live-split__main.is-split-dragging
        .weeduc-admin-site-editor-live-split__splitter-grip {
        background: linear-gradient(180deg, #250891 0%, #4f46e5 100%);
        box-shadow:
            inset 0 0 0 1px rgba(255, 255, 255, 0.2),
            0 0 0 2px rgba(37, 8, 145, 0.2);
    }

    .weeduc-admin-site-editor-live-split__main.is-split-dragging {
        cursor: col-resize;
    }

    .weeduc-admin-site-editor-live-split__main.is-split-dragging
        .weeduc-admin-site-published-preview__iframe {
        pointer-events: none;
    }

    .weeduc-admin-site-editor-live-split__live.weeduc-admin-site-published-preview {
        margin-bottom: 0;
        position: relative;
        top: auto;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
        align-self: stretch;
    }

    .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__live.weeduc-admin-site-published-preview {
        max-height: none;
    }

    .weeduc-admin-site-editor-live-split--preview-only
        .weeduc-admin-site-published-preview {
        position: relative;
        top: auto;
    }

    /* « Só preview »: largura/altura maiores; o site rola dentro do iframe */
    .weeduc-admin-site-layout--solo-preview .weeduc-admin-site-editor-live-split {
        width: 100%;
        max-width: min(1920px, 100%);
        margin-left: auto;
        margin-right: auto;
    }

    .weeduc-admin-site-layout--solo-preview
        .weeduc-admin-site-editor-live-split__main {
        width: 100%;
        align-items: stretch;
        min-height: min(calc(100vh - 120px), 1680px);
    }

    .weeduc-admin-site-layout--solo-preview
        .weeduc-admin-site-published-preview.weeduc-admin-site-editor-live-split__live {
        width: 100%;
        max-width: min(1920px, 100%);
        min-height: calc(100vh - 10rem);
    }

    .weeduc-admin-site-editor-live-split__main--solo-preview {
        justify-content: center;
        width: 100%;
    }

    .weeduc-admin-site-published-preview {
        margin-bottom: 1.25rem;
        padding: 1rem 1.1rem;
        border-radius: 12px;
        border: 1px solid #e8eaf0;
        background: #fafbfc;
    }

    .weeduc-admin-site-published-preview__head {
        position: relative;
        padding-right: 2.35rem;
        flex-shrink: 0;
    }

    .weeduc-admin-site-published-preview__head-open {
        position: absolute;
        top: 0;
        right: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2.125rem;
        height: 2.125rem;
        border-radius: 8px;
        border: 1px solid #e0e3ea;
        background: #fff;
        color: #250891;
        text-decoration: none;
        transition:
            background 0.15s ease,
            border-color 0.15s ease,
            color 0.15s ease;
    }

    .weeduc-admin-site-published-preview__head-open:hover {
        border-color: rgba(37, 8, 145, 0.35);
        background: rgba(37, 8, 145, 0.06);
        color: #1c0668;
    }

    .weeduc-admin-site-published-preview__head-open-icon {
        width: 0.95rem;
        height: 0.95rem;
    }

    .weeduc-admin-site-published-preview__title {
        margin: 0;
        padding-right: 0.15rem;
        font-size: 1rem;
        font-weight: 600;
        color: #1a1d24;
    }

    .weeduc-admin-site-published-preview__device {
        width: 100%;
        margin-top: 0.75rem;
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .weeduc-admin-site-published-preview__device--mobile {
        max-width: 390px;
        margin-left: auto;
        margin-right: auto;
    }

    .weeduc-admin-site-published-preview__device--mobile
        .weeduc-admin-site-published-preview__frame-wrap {
        border-radius: 22px;
        box-shadow:
            0 12px 40px rgba(0, 0, 0, 0.12),
            0 0 0 1px rgba(0, 0, 0, 0.06);
    }

    .weeduc-admin-site-published-preview__frame-wrap {
        position: relative;
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #e0e3ea;
        background: #fff;
    }

    /* Evita faixa demasiado baixa onde só se percebe o rodapé do site */
    .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-published-preview__frame-wrap {
        min-height: min(520px, 62vh);
    }

    .weeduc-admin-site-published-preview__frame-wrap.is-preview-loading
        .weeduc-admin-site-published-preview__iframe {
        visibility: hidden;
    }

    .weeduc-admin-site-published-preview__frame-loading {
        position: absolute;
        inset: 0;
        z-index: 3;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 1rem;
        background: rgba(248, 249, 251, 0.97);
        pointer-events: none;
    }

    .weeduc-admin-site-published-preview__spinner {
        width: 2.25rem;
        height: 2.25rem;
        border: 3px solid #e8eaf0;
        border-top-color: #250891;
        border-radius: 50%;
        animation: weeduc-admin-preview-spin 0.7s linear infinite;
    }

    @keyframes weeduc-admin-preview-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .weeduc-admin-site-published-preview__loading-text {
        font-size: 13px;
        font-weight: 500;
        color: #5c6370;
    }

    .weeduc-admin-site-published-preview__iframe {
        display: block;
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        height: 100% !important;
        border: 0;
    }

    .weeduc-admin-site-published-preview__device--tablet {
        max-width: 768px;
        margin-left: auto;
        margin-right: auto;
    }

    .weeduc-admin-site-published-preview__device--tablet
        .weeduc-admin-site-published-preview__frame-wrap {
        border-radius: 14px;
        box-shadow:
            0 8px 28px rgba(0, 0, 0, 0.1),
            0 0 0 1px rgba(0, 0, 0, 0.05);
    }

    .dashboard.dark .weeduc-admin-site-published-preview {
        border-color: #3d414d;
        background: #22252c;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__title {
        color: #e8eaf0;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__head-open {
        background: #2a2d36;
        border-color: #4a5058;
        color: #c5cae0;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__head-open:hover {
        border-color: #6d5acd;
        background: rgba(109, 90, 205, 0.18);
        color: #fff;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__frame-wrap {
        border-color: #3d414d;
        background: #1a1d24;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__frame-loading {
        background: rgba(26, 29, 36, 0.97);
    }

    .dashboard.dark .weeduc-admin-site-published-preview__spinner {
        border-color: #3d414d;
        border-top-color: #6d5acd;
    }

    .dashboard.dark .weeduc-admin-site-published-preview__loading-text {
        color: #a8b0c0;
    }

    .dashboard.dark .weeduc-admin-site-preview-toolbar {
        border-color: #3d414d;
        background: #2a2d36;
    }

    .dashboard.dark .weeduc-admin-site-preview-toolbar__sep {
        background: #4a5058;
    }

    .dashboard.dark .weeduc-admin-site-preview-toolbar__btn:not(
            .weeduc-admin-site-preview-toolbar__btn--active
        ) {
        background: #1e2028;
        border-color: #4a5058;
        color: #e8eaf0;
    }

    .dashboard.dark .weeduc-admin-site-preview-toolbar__btn:not(
            .weeduc-admin-site-preview-toolbar__btn--active
        ):hover {
        border-color: #6d5acd;
        color: #fff;
    }

    .dashboard.dark .weeduc-admin-site-fullscreen-backdrop {
        background: rgba(0, 0, 0, 0.62);
    }

    .dashboard.dark .weeduc-admin-site-layout-stack--modal {
        background: #1a1d24;
        box-shadow:
            0 25px 50px -12px rgba(0, 0, 0, 0.55),
            0 0 0 1px rgba(255, 255, 255, 0.06);
    }

    .dashboard.dark .weeduc-admin-site-fullscreen-topbar {
        background: #252730;
        border-color: #3d414d;
    }

    .dashboard.dark .weeduc-admin-site-fullscreen-topbar__title {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-site-fullscreen-topbar__close {
        background: #1e2028;
        border-color: #4a5058;
        color: #e8eaf0;
    }

    .dashboard.dark .weeduc-admin-site-fullscreen-topbar__close:hover {
        border-color: #6d5acd;
        color: #fff;
    }

    /* Mesmo tema quando o modal está em Teleport (fora de .dashboard) */
    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-fullscreen-backdrop {
        background: rgba(0, 0, 0, 0.62);
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-layout-stack--modal {
        background: #1a1d24;
        box-shadow:
            0 25px 50px -12px rgba(0, 0, 0, 0.55),
            0 0 0 1px rgba(255, 255, 255, 0.06);
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-fullscreen-topbar {
        background: #252730;
        border-color: #3d414d;
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-fullscreen-topbar__title {
        color: #f1f3f7;
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-fullscreen-topbar__close {
        background: #1e2028;
        border-color: #4a5058;
        color: #e8eaf0;
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-fullscreen-topbar__close:hover {
        border-color: #6d5acd;
        color: #fff;
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-preview-toolbar {
        border-color: #3d414d;
        background: #252730;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__editor {
        background: linear-gradient(180deg, #22252d 0%, #1e2028 100%);
    }

    .weeduc-admin-site-fs-portal--dashboard-dark.weeduc-admin-site-fs-portal--open
        .weeduc-admin-site-layout-stack--modal
        .weeduc-admin-site-editor-live-split__main--split
        .weeduc-admin-site-editor-live-split__live.weeduc-admin-site-published-preview {
        border-left-color: #3d414d;
        background: linear-gradient(180deg, #252730 0%, #1a1d24 100%);
        box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.04);
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__panel {
        background: #252730;
        border-color: #3d414d;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__title {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__lead {
        color: #a8b0c0;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__lead code {
        background: #2a2d36;
        color: #e8eaf0;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__label {
        color: #c5cad6;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__native {
        border-color: #4a5058;
        background: #1e2028;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__hex {
        background-color: #2a2d36;
        color: #f1f3f7;
        border-color: #3d414d;
    }

    .dashboard.dark .weeduc-admin-brand-color-modal__btn-cancel {
        background: #2a2d36;
        border-color: #4a5058;
        color: #e8eaf0;
    }

    .dashboard.dark .weeduc-admin-site-editor-live-split__splitter-grip {
        background: #5c6370;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
    }

    .dashboard.dark
        .weeduc-admin-site-editor-live-split__splitter-hit:hover
        .weeduc-admin-site-editor-live-split__splitter-grip,
    .dashboard.dark
        .weeduc-admin-site-editor-live-split__main.is-split-dragging
        .weeduc-admin-site-editor-live-split__splitter-grip {
        background: linear-gradient(180deg, #392497 0%, #6d5acd 100%);
    }

    @media (max-width: 1100px) {
        .weeduc-admin-site-editor-live-split__main--split {
            flex-direction: column;
        }

        .weeduc-admin-site-editor-live-split__splitter-hit {
            display: none;
        }

        .weeduc-admin-site-editor-live-split__main--split
            .weeduc-admin-site-editor-live-split__live.weeduc-admin-site-published-preview {
            flex: 1 1 auto !important;
            width: 100% !important;
            max-width: 100% !important;
            position: static;
        }

        .weeduc-admin-site-editor-live-split__live .weeduc-admin-site-published-preview__iframe {
            height: 100%;
            min-height: 0;
        }
    }

    .content-button.site {
        position: fixed;
        right: 32px;
        bottom: 32px;
        z-index: 100 !important;
    }
    button.btn.btn-block.btn-content {
        max-width: 250px !important;
        padding: 8px 40px !important;
    }
    @media (max-width: 768px) {
        /* .site_content.weeduc-admin-content.main-container {
            padding: 0px 0px 0px 10px !important;
        } */
        button.btn.btn-block.btn-content {
            max-width: 100% !important;
            padding: 8px 40px !important;
        }
        .site_content.weeduc-admin-content.main-container
            .banner-content.cursos.d-flex.align-items-center {
            display: flex;
            flex-direction: column;
        }
        .global-site-weeduc
            .weeduc-admin-content
            .config-form.primary.col-12.itens-courses
            .banner-text {
            width: 100% !important;
        }
        .global-site-weeduc .weeduc-admin-content .depoimento-image img {
            width: 40px !important;
        }
        .global-site-weeduc .weeduc-admin-content .depoimentos-slider {
            gap: 10px !important;
        }
        .weeduc-admin-content .redes-sociais .rede-social svg {
            color: #250891;
        }
    }
</style>
